import { toast } from "react-toastify";
import { PhoneKey } from "src/assets/svgs";
import { toggleSidebar } from "src/store/context/reducer";
import { useAppDispatch, useAppSelector } from "src/store/hooks";

export default function DialerAction() {
  const dispatch = useAppDispatch();
  const { paused } = useAppSelector((state) => state.auth);

  const handleToggleDialer = () => {
    if (!paused) return toast.error("Aplique uma pausa para usar o discador.");

    return dispatch(toggleSidebar("outsideDialer"));
  };

  return (
    <div className="p-8 pt-4 flex">
      <button
        onClick={handleToggleDialer}
        type="button"
        className="border text-lg border-primary-blue-400 rounded-lg py-4 px-6 flex flex-1 justify-between text-primary-blue-400 hover:bg-primary-blue-800 hover:text-white items-center transition-all group dark:text-white dark:border-white hover:border-primary-blue-400"
      >
        <span className="text-lg">Abrir discador</span>

        <PhoneKey className="group-hover:fill-white fill-primary-blue-400 dark:fill-white" />
      </button>
    </div>
  );
}
